import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import { AuthService } from "services/AuthServices";
// import { UserService } from "services/UserService";
import Cookies from 'universal-cookie';
import { encryptedDataAES, encryptedDataRSA, generateRSAKey } from "utils/Encryption";
import { v4 as uuidv4 } from 'uuid';


const cookies = new Cookies()
const token = cookies.get('X-AUTH-TOKEN-ENC')
const key = cookies.get('KEY-ENC')
// export const register = createAsyncThunk(
//   "auth/register",
//   async ({ username, email, password }, thunkAPI) => {
//     try {
//       const response = await AuthService.register(username, email, password);
//       thunkAPI.dispatch(setMessage(response.data.message));
//       return response.data;
//     } catch (error) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       thunkAPI.dispatch(setMessage(message));
//       return thunkAPI.rejectWithValue();
//     }
//   }
// );
// export const login = createAsyncThunk(
//   "auth/login",
//   async (payload, thunkAPI) => {
//     try {
//       let key = generateRSAKey()

//       cookies.set('KEY', key, { path: '/' });
//       let randomKeyEnc = encryptedDataRSA(key)
//       cookies.set('KEY-ENC', randomKeyEnc, { path: '/' });
//       let ticketIdEnc = encryptedDataAES(payload.ticket, key)

//       let request = {
//         requestId: "58f54b64-3c08-11ee-be56-0242ac120002",
//         randomKeyEnc: randomKeyEnc,
//         ticketIdEnc: ticketIdEnc
//       }

//       const data = await AuthService.login(request);

//       return {
//         token: data.token,
//         key: data.key,
//         errorDescription: data.errorDescription,
//         errorCode: data.errorCode
//       };

//     } catch (error) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       thunkAPI.dispatch(setMessage(message));
//       return thunkAPI.rejectWithValue();
//     }
//   }
// );
export const login = createAsyncThunk(
  "auth/login",
  async (payload, thunkAPI) => {
    try {
      let key = generateRSAKey();
      cookies.set('KEY', key, { path: '/' });
      let randomKeyEnc = encryptedDataRSA(key)
      cookies.set('KEY-ENC', randomKeyEnc, { path: '/' });
     
      let ticketIdEnc = encryptedDataAES(payload.ticket, key)
      let request = {
        requestId: uuidv4(),
        randomKeyEnc: randomKeyEnc,
        ticketIdEnc: ticketIdEnc,
      //  type:1
      };
      const data = await AuthService.login(request);
      cookies.set('X-AUTH-TOKEN-ENC', data.token, { path: '/' });
      cookies.set('KEY-ENC', data.key, { path: '/' });
      return {
        token: data.token,
        key: data.key,
        errorDescription: data.errorDescription,
        errorCode: data.errorCode
      };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


// export const user = createAsyncThunk(
//   "auth/user",
//   async (thunkAPI) => {
//     try {
//       const data = await UserService.getUserProfile();
//       return {
//         user: data.user,
//         message: data.message,
//         success: data.success
//       };

//     } catch (error) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       thunkAPI.dispatch(setMessage(message));
//       return thunkAPI.rejectWithValue();
//     }
//   }
// );
export const logout = createAsyncThunk("auth/logout", async () => {
  await AuthService.logout();
});
const initialState = token
  ? { isLoggedIn: true, token, key }
  : { isLoggedIn: false, token: null, key: null };

const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: {
    // [register.fulfilled]: (state, action) => {
    //   state.isLoggedIn = false;
    // },
    // [register.rejected]: (state, action) => {
    //   state.isLoggedIn = false;
    // },
    [login.fulfilled]: (state, action) => {
      state.isLoggedIn = true;
      state.token = action.payload.token;
      state.key = action.payload.key;
    },
    [login.rejected]: (state, action) => {
      state.isLoggedIn = false;
      state.token = null;
      state.key = null;
    },
    [logout.fulfilled]: (state, action) => {
      state.isLoggedIn = false;
      state.token = null;
      state.key = null;
      state.user = null;
    },

    // [user.fulfilled]: (state, action) => {
    //   state.isLoggedIn = true;
    //   state.user = action.payload.user;
    //   state.token = token;
    //   state.key = key;
    // },
    // [user.rejected]: (state, action) => {
    //   state.isLoggedIn = false;
    //   state.token = null;
    //   state.user = null;
    // },
  },
});
const { reducer } = authSlice;
export default reducer;